import React from 'react';
import { TooltipComponent } from '../../../../charts/core/tooltip/Tooltip';
import { ChartTooltip } from '../../../../components/Widgets/ChartTooltip/ChartTooltip';
import { ChartTooltipInteraction } from '../../../../components/Widgets/ChartTooltip/ChartTooltipInteraction';
import { ChartTooltipItem } from '../../../../components/Widgets/ChartTooltip/ChartTooltipItem';
import { ChartClickInteraction } from '../../../../components/Widgets/types';
import type { DatumWithColor, InteractionArgs, PieWidgetDataEntry } from './PieSeriesAdapter';

type PieTooltipProps = {
  clickInteractions?: ChartClickInteraction[];
  buildInteractionArgs: (datum: PieWidgetDataEntry, index: number) => InteractionArgs;
  data: DatumWithColor[];
  metricDisplayName?: string | number | null;
  measurementDescription: string;
};
export const PieTooltipComponent: TooltipComponent<DatumWithColor, PieTooltipProps> = props => {
  const {
    getColor,
    labelFormatter,
    valueFormatter,
    buildInteractionArgs,
    data,
    isPinned,
    tooltipData,
    metricDisplayName,
    clickInteractions,
    measurementDescription,
  } = props;

  const enabledInteractions = clickInteractions?.filter(i => i.isEnabledForCell(tooltipData)) ?? [];
  const interactionArgs = buildInteractionArgs(tooltipData, data.indexOf(tooltipData));
  const getSingleInteractionText = (text?: string) => (enabledInteractions.length === 1 ? `Click to ${text}` : text);

  return (
    <ChartTooltip
      interactionsMenuOpen={isPinned}
      minWidth={221}
      maxWidth={221}
      boxShadow={t => t.shadows[10]}
      titleSlot={<ChartTooltipItem dotColor={getColor(tooltipData)} title={labelFormatter?.(tooltipData, { where: 'tooltip' })} />}
      interactions={
        enabledInteractions.length > 1 && !isPinned ? (
          <ChartTooltipInteraction primary="Click for interactions" />
        ) : (
          enabledInteractions.map(interaction => (
            <ChartTooltipInteraction
              key={interaction?.title}
              primary={getSingleInteractionText(interaction?.title)}
              icon={interaction?.icon}
              onClick={() => interaction?.onClick(interactionArgs)}
            />
          ))
        )
      }>
      <ChartTooltipItem
        title={metricDisplayName?.toString()}
        value={valueFormatter?.(tooltipData, { where: 'tooltip' })}
        description={measurementDescription}
      />
    </ChartTooltip>
  );
};
